<script>
  import { birthData } from "../stores/birthData.js";

  // Use the $ sign to create reactive variables
  $: name = $birthData.name;
  $: date = $birthData.date;
  $: time = $birthData.time;
  $: location = $birthData.location;
  $: tzName = $birthData.tzName;
  $: longitude = $birthData.longitude;
  $: latitude = $birthData.latitude;
/*
  // Add leading zero to single digit numbers
  function padding(number) {
    return number.toString().padStart(2, "0");
  }
*/
  function decimalToDMS(decimal) {
    const degrees = Math.floor(decimal);
    const minutes = Math.floor((decimal - degrees) * 60);
    const seconds = Math.round((decimal - degrees - minutes / 60) * 3600);
    const paddedDegrees = degrees.toString().padStart(3, "0");
    const paddedMinutes = minutes.toString().padStart(2, "0");
    const paddedSeconds = seconds.toString().padStart(2, "0");
    return `${paddedDegrees}° ${paddedMinutes}' ${paddedSeconds}"`;
  }

  function readableLatitude() {
    const hemisphere = latitude >= 0 ? "N" : "S";
    return `${decimalToDMS(Math.abs(latitude))} ${hemisphere}`;
  }

  function readableLongitude() {
    const hemisphere = longitude >= 0 ? "E" : "W";
    return `${decimalToDMS(Math.abs(longitude))} ${hemisphere}`;
  }

</script>
<div class="details">
    <p>Horoscoop van: <strong>{name}</strong>, <span class="mobile-only"><br></span>{date} {time} {tzName}</p>
    <p>{location}</p>
    <p>{readableLongitude(longitude)} {readableLatitude(latitude)}</p>
  </div>
<style>
.details {
    margin: 0 auto;
    max-width: 100%;
    background-color: whitesmoke;
    padding: 1rem;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .details p {
    margin-top: 1px;
    margin-bottom: 1px;
  }
  @media (min-width: 400px) {
    .mobile-only {
      display: none;
    }
  }
</style>